export const toggleItemInArray = (array, item) =>
  array?.includes(item)
    ? [...array.filter((x) => x !== item)]
    : [...array, item];
